import React, { FC } from "react";

import ModalContainer from "../UIElements/modal-container";
import SelectInput from "../UIElements/select";
import { useMutation } from "@tanstack/react-query";
import { useNotificationService } from "../notification";
import { apiUpdateJobStatus } from "../../api/jobs";
import { Box, Button, Stack, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";

export const JobUpdateModal: FC<{
  open: boolean;
  jobId: string;
  handleModal: () => void;
  modalStatus: string;
  setModalStatus: React.Dispatch<React.SetStateAction<string>>;
}> = ({ open, handleModal, jobId, modalStatus, setModalStatus }) => {
  const { showNotification } = useNotificationService();

  const mutation = useMutation({
    mutationFn: (fieldValues: { status: string; jobId: string }) =>
      apiUpdateJobStatus(fieldValues),
    onSuccess: (data) => {
      if (data?.status === "error") {
        if ("msg" in data) {
          showNotification(data?.msg ?? "", "error");
          return;
        }
        return;
      }
      if ("data" in data) {
        showNotification(data?.data?.message ?? "Status Updated");
        handleModal();
      }
    },
    onError: (error) => {
      showNotification("Fetch process failed", "error");
    },
  });
  const handleStatus = () => {
    const form = {
      status: modalStatus,
      jobId: jobId,
    };
    mutation.mutate(form);
  };
  return (
    <ModalContainer
      sx={{
        borderRadius: "16px",
      }}
      size={"xs"}
      openModal={open}
      fullWidth={true}
      handleModal={handleModal}
    >
      <Box
        sx={{
          background: "#fff",
          padding: 3,
          borderRadius: "16px",
        }}
      >
        <Stack>
          <Typography
            variant="h6"
            sx={{
              fontFamily: "Outfit",
              fontWeight: 500,
              color: "#292925",
              marginBottom: 3,
            }}
          >
            Update job status
          </Typography>
          <SelectInput
            label={"Select Status"}
            value={modalStatus}
            onChange={(e) => setModalStatus(e.target.value)}
            options={[
              { value: "active", label: "Active" },
              { value: "pending", label: "Pending" },
              { value: "closed", label: "Closed" },
            ]}
          />
          <Stack direction="row" spacing={3} justifyContent={"flex-end"}>
            <Button
              variant="outlined"
              onClick={handleModal}
              sx={{ borderRadius: "8px" }}
            >
              Cancel
            </Button>
            <LoadingButton
              variant="contained"
              color="primary"
              loading={mutation.isPending}
              onClick={handleStatus}
              sx={{ borderRadius: "6px" }}
            >
              Update
            </LoadingButton>
          </Stack>
        </Stack>
      </Box>
    </ModalContainer>
  );
};
